export default "__VITE_ASSET__C2jGdmY9__"